var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAtom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 135.46666 135.46667",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title1"
  }, "Atom") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title1"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3",
    transform: "matrix(0.20169075,0,0,0.2002195,16.270367,16.481973)",
    style: {
      strokeWidth: 1.31664
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2",
    style: {
      display: "inline",
      strokeWidth: 1.31896
    },
    transform: "matrix(0.99648074,0,0,1,0.05871787,-0.02413517)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      strokeWidth: 13.1896,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1",
    cx: 256,
    cy: 256,
    rx: 88.03846,
    ry: 246.15382
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      strokeWidth: 13.1896,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1-9",
    cx: 256,
    cy: -256,
    rx: 88.03846,
    ry: 246.15382,
    transform: "rotate(90)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      vectorEffect: "none",
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 13.1896,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      InkscapeStroke: "none",
      stopColor: "#000000",
      stopOpacity: 1
    },
    id: "path1-9-4",
    cx: 14.549315,
    cy: 361.74622,
    rx: 88.03846,
    ry: 246.15382,
    transform: "matrix(-0.67811893,0.73495219,0.73495219,0.67811893,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fontVariationSettings: "normal",
      vectorEffect: "none",
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 13.1896,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      InkscapeStroke: "none",
      stopColor: "#000000"
    },
    id: "path1-9-4-6",
    cx: 361.74622,
    cy: -14.549316,
    rx: 88.03846,
    ry: 246.15382,
    transform: "rotate(47.303176)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      vectorEffect: "none",
      fillOpacity: 1,
      strokeWidth: 13.1664,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      InkscapeStroke: "none"
    },
    id: "path2",
    cx: 256,
    cy: 256,
    rx: 51.692307,
    ry: 52.923077
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtom);
export default __webpack_public_path__ + "static/media/atom.1e4c957d20fb94c2df453353c1d9e7c4.svg";
export { ForwardRef as ReactComponent };